import { render, staticRenderFns } from "./buffets.vue?vue&type=template&id=72bf16f8&scoped=true&"
import script from "./buffets.vue?vue&type=script&lang=js&"
export * from "./buffets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf16f8",
  null
  
)

export default component.exports